import { render, staticRenderFns } from "./VirtualPubSectionPanel.vue?vue&type=template&id=a77c4016&scoped=true"
import script from "./VirtualPubSectionPanel.vue?vue&type=script&lang=ts"
export * from "./VirtualPubSectionPanel.vue?vue&type=script&lang=ts"
import style0 from "./VirtualPubSectionPanel.vue?vue&type=style&index=0&id=a77c4016&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77c4016",
  null
  
)

export default component.exports